import React from 'react';
import { SkeletonBlock } from '../../../components/skeleton/skeleton';

// Admin Image Library sayfasının ilk paint iskeleti: header + arama +
// shimmer'lı galeri grid'i (gerçek grid ile aynı kart formu).
const ImageLibraryAdminSkeleton = () => (
  <div className="min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
    <div className="mx-auto max-w-6xl space-y-6">
      <div className="space-y-2">
        <SkeletonBlock className="h-7 w-48" />
        <SkeletonBlock className="h-4 w-80 max-w-full" />
      </div>

      <SkeletonBlock className="h-10 w-72 max-w-full !rounded-md" />

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="overflow-hidden rounded-xl border border-slate-200 dark:border-slate-700"
          >
            <div className="ilb-skeleton aspect-square w-full" />
            <div className="ilb-skeleton mx-3 my-2.5 h-3.5 w-2/3 rounded" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ImageLibraryAdminSkeleton;
